import { useEffect, useState } from 'react';
import { useTranslation } from 'next-i18next';
import SectionAccordion from '_components/UI/SectionAccordion';
import trackBazaarvoiceEvent from '@utils/gtm/ga4/trackBazaarvoiceEvents';
import styles from './ProductAskAndAnswer.module.scss';

const ProductAskAndAnswer = ({
  productCode,
  reviewCount,
}: {
  productCode: string;
  reviewCount: number;
}) => {
  const { t } = useTranslation('pdp');
  const [isBazaarvoiceReady, setIsBazaarvoiceReady] = useState(true);

  useEffect(() => {
    const bazaarvoiceDiv = document.getElementById('askAnswer');
    if (!bazaarvoiceDiv) return;

    setIsBazaarvoiceReady(true);

    const checkReady = () => {
      const isReady = bazaarvoiceDiv.getAttribute('data-bv-ready') === 'true';
      if (isReady) setIsBazaarvoiceReady(false);
      return isReady;
    };

    if (checkReady()) return;

    const observer = new MutationObserver(() => {
      if (checkReady()) observer.disconnect();
    });

    observer.observe(bazaarvoiceDiv, {
      attributes: true,
      attributeFilter: ['data-bv-ready'],
    });

    return () => observer.disconnect();
  }, [productCode]);

  return (
    <SectionAccordion
      icon="plus"
      size="large"
      className={styles.productAskAndAnswerSection}
      disabled={isBazaarvoiceReady}
      onStateChange={(state) => {
        if (state === 'open') trackBazaarvoiceEvent('Ask & answer');
      }}
    >
      <SectionAccordion.Header
        className={styles.productAskAndAnswerHeader}
        title={
          <span className={styles.productAskAndAnswerTitle}>
            {t('product.ask.answer.new')}
          </span>
        }
        subtitle={
          <span className={styles.productAskAndAnswerSubtitle}>
            {reviewCount !== 1
              ? t('product.reviews.count', { count: reviewCount })
              : t('product.reviews.count.one', { count: reviewCount })}
          </span>
        }
      />
      <SectionAccordion.Collapsible>
        <div
          id="askAnswer"
          data-bv-show="questions"
          data-bv-product-id={productCode}
          data-testid="askAnswer"
        />
      </SectionAccordion.Collapsible>
    </SectionAccordion>
  );
};

export default ProductAskAndAnswer;
